import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Button, Col, Modal, Row, Table } from 'react-bootstrap';
import { userStore } from 'store/UserStore';
import RedeemGiftModal from './RedeemGiftModal';
import giftHttp from './services/gift.service';
import { Pagination } from 'shared/common/pagination';
import Loader from 'shared/common/loader';
import './style.css';
import giftService from './services/gift.service';
import GiftModal from 'pages/Corporate-gifting/GiftModal';
import SuccessGiftModal from 'pages/Corporate-gifting/SuccessGiftModal';
import { useHistory } from 'react-router-dom';

interface PropsType {
  getPassbookSummary?: any;
}

const metalMapping = {
  "Au": "Gold",
  "Ag": "Silver",
  "Pt": "Platinum",
  "Pd": "Palladium"

}

const ReceivedGifts: React.FC<PropsType> = ({ getPassbookSummary }) => {
  const [loading, setLoading] = useState<any>(false);
  const [customerId, setUser, user, userData, setCustomer, customer] =
    userStore((state: any) => [
      state.customerId,
      state.setUser,
      state.user,
      state.userData,
      state.setCustomer,
      state.customer,
    ]);
  const [open, setOpen] = useState<any>(false);
  const [isAcceptGift, setIsAcceptGift] = useState<any>(false);
  const [orderRef, setOrderRef] = useState<any>('');
  const [giftsList, setGiftsList] = useState<any>([]);
  const [metaData, setMetaData] = useState<any>({});
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [senderCustId, setSenderCustId] = useState<number>(0);
  const [selectedMessage, setSelectedMessage] = useState<string | null>(null);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState<boolean>(false);

  // corporate gifting
  const [corpGiftCode, setCorpGiftCode] = useState<string | null>("");
  const [corpGiftMessage, setCorpGiftMessage] = useState<string | null>(null);
  const [showCorpGiftModal, setShowCorpGiftModal] = useState<boolean>(false);
  const [showCorpSuccessModal, setShowCorpSuccessModal] =
    useState<boolean>(false);
  const history = useHistory();

  const isValidGiftCode = async (code: any) => {
    try {
      const data = {
        voucherCode: code,
      };
      const res = await giftService.isValidGiftCode(data);
      console.log(res.data.data.GiftMessage);
      setCorpGiftMessage(res.data.data.GiftMessage);
      if (res.data.data.isValid) {
        setShowCorpGiftModal(true);
      } else {
        toast.error('Invalid Voucher Code!');
      }
    } catch (err: any) {
      toast.error(err?.data?.errors[0]?.title);
      console.log(err);
    }
  };
  const claimCorporateGift = async () => {
    try {
      const data = {
        corpVoucherId: corpGiftCode,
        partnerId: customer?.partner?.id,
      };
      setLoading(true);
      const res = await giftService.acceptCorporateGift(data);
      if (res.status == 201 && res.data.data.message == 'success') {
        setLoading(false);
        setShowCorpGiftModal(false);
        toast.success('Gift Claimed Successfully!');
        setShowCorpSuccessModal(true);
        setCorpGiftCode('');
      } else {
        setLoading(false);
        toast.error('Something went wrong!');
        setShowCorpGiftModal(false);
        setCorpGiftCode('');
      }
    } catch (err: any) {
      console.log(err);
      setLoading(false);
      toast.error('Something went wrong!');
      setShowCorpGiftModal(false);
      setCorpGiftCode('');
    }
  };
  const redirectToPassbook = () => {
    history.push('/buy-sell');
  };

  const closeGiftModal = () => {
    setShowCorpGiftModal(false);
  };
  const closeGiftSuccessModal = () => {
    setShowCorpSuccessModal(false);
  };
  const redeemCorpGift = () => {
    try {
      isValidGiftCode(corpGiftCode);
    } catch (err) {
      console.log(err);
    }
  };
  // end of corporate gifting

  const handleShowMessage = (message: string) => {
    setSelectedMessage(message);
    setIsMessageModalOpen(true);
  };

  const handleCloseMessage = () => {
    setIsMessageModalOpen(false);
    setSelectedMessage('');
  };

  const getMetalName = (code) => {
    return metalMapping[code] || "Unknown Metal";
  };


  const rejectModalOpen = (orderRefId, senderId) => {
    setOpen(true);
    setOrderRef(orderRefId);
    setSenderCustId(senderId);
  };

  const onCancel = () => {
    setOpen(false);
  };

  const receivedGiftsList = async (page) => {
    try {
      const number = customer?.kyc?.mobile?.value.split('+');
      const res = await giftHttp.receievedGiftsList(
        number[1],
        customer?.partner?.id,
        page
      );
      if (res?.status == 200) {
        setGiftsList(res?.data?.data?.result);
        setCurrentPage(page);
        setMetaData({
          current: res.data.meta.page,
          pages: res.data.meta.totalPages + 1,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };
  const rejectGiftFunc = async () => {
    try {
      const payload = {
        ebOrderRefs: orderRef,
        gift: 'true',
        sendersId: senderCustId,
      };
      const res = await giftHttp.rejectGift(payload);
      if (res?.status == 200) {
        toast.success('Gift Rejected successfully!');

        receivedGiftsList(0);
        setOpen(false);
      }
    } catch (err) {
      setOpen(false);
      toast.error("Something went wrong!");
      console.log(err);
    }
  };

  const acceptGiftFunc = async (giftId) => {
    try {
      setIsAcceptGift(true);
      setLoading(true);
      const payload = {
        giftId: giftId,
        partnerId: customer?.partner?.id,
      };
      const res = await giftHttp.acceptGift(payload);

      if (res?.status) {
        toast.success('Gift Accepted Successfully');
        receivedGiftsList(0);
        getPassbookSummary();
        setIsAcceptGift(false);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      toast.error('Something went wrong');
      setIsAcceptGift(false);
      setLoading(false);
    }
  };


  useEffect(() => {
    receivedGiftsList(0);
  }, []);



  return (
    <>
      {loading && <Loader />}
      <div
        style={{
          boxShadow:
            'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
          padding: '15px 20px',
          backgroundColor: '#eae6dd',
          border: '0.15px solid #99834d',
          borderRadius: '15px',
        }}
      >
        <h5 style={{ fontSize: '16px', fontWeight: 700 }}>
          Got a Gift Voucher? Use it Here!
        </h5>
        <div>
          <input
            type='text'
            style={{
              width: '50%',
              padding: '6px',
              borderRadius: '4px',
              border: '1px solid #ced4da',
              marginBottom: '6px',
              backgroundColor: '#f8f9fa',
              marginRight: '10px',
            }}
            value={corpGiftCode}
            onChange={(e) => setCorpGiftCode(e.target.value.toUpperCase())}
            maxLength={11}
          />
          <button className='btn btn-primary btn-sm' disabled={corpGiftCode==""} onClick={redeemCorpGift}>
            Redeem Gift
          </button>
        </div>
      </div>
      <div className='t-wrap overflow-auto'>
        <Table className='mb-0 w-100 txn__table' striped hover responsive>
          <thead>
            <tr>
              {/* <th>Id</th> */}
              <th>From</th>
              {/* <th>Mobile</th> */}
              <th>Metal</th>
              <th>Quantity</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {giftsList[0] ? (
              giftsList?.map((gift, index) => (
                <tr key={index}>
                  <td>{gift?.displayName}</td>
                  <td>{getMetalName(gift?.metal)}</td>
                  <td>{gift?.metalQuantity}g</td>
                  <td> <div
                    className={`badge ${gift?.status == 'ACCEPTED'
                      ? 'bg-success'
                      : 'bg-secondary'
                      }`}
                  >
                    {gift?.status}
                  </div></td>


                  <td>
                    <div className="button-container">
                      {gift?.status === 'ACTIVE' && (
                        <>
                          <Button
                            variant='primary'
                            bsPrefix='btn-table'
                            onClick={() => acceptGiftFunc(gift?.id)}
                            disabled={isAcceptGift}
                          >
                            Accept
                          </Button>
                          <Button
                            variant='primary'
                            bsPrefix='btn-table'
                            onClick={() =>
                              rejectModalOpen(gift?.ebOrderRef, gift?.customerId)
                            }
                          >
                            Reject
                          </Button>
                        </>
                      )}

                      {gift?.message.length > 0 && (
                        <Button
                          bsPrefix='btn-table'
                          className='view-btn'
                          onClick={() => handleShowMessage(gift?.message)}
                        >
                          View Message
                        </Button>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5}>
                  <div className='m-2 d-flex justify-content-center'>
                    No data to display
                  </div>
                </td>
              </tr>
            )}

            {/* )} */}
          </tbody>
        </Table>
        <Modal show={isMessageModalOpen} onHide={handleCloseMessage} centered>
          <Modal.Header closeButton>
            <Modal.Title> 🎁  A special note just for you! </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{selectedMessage}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={handleCloseMessage}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <RedeemGiftModal
          showModal={open}
          closeModal={setOpen}
          proceed={rejectGiftFunc}
          cancel={onCancel}
          text={'Are you sure, you want to reject gift.'}
          okButton={'Proceed'}
          cancelButton={'Cancel'}
        />
      </div>
      <Row>
        <Col md={12}>
          {/* Pagination Bar */}
          {!loading && metaData.pages > 1 && (
            <Pagination
              meta={metaData}
              handlePageChange={(number: number) => receivedGiftsList(number)}
            />
          )}
        </Col>
      </Row>

      {/* corporate gifting */}
      <GiftModal
        showModal={showCorpGiftModal}
        closeModal={() => {
          closeGiftModal(); // Close GiftModal
          setOpen(false); // Ensure RedeemGiftModal stays closed
        }}
        cancel={closeGiftModal}
        proceed={claimCorporateGift}
        corpGiftMessage={corpGiftMessage}
      />

      <SuccessGiftModal
        showModal={showCorpSuccessModal}
        cancel={() => {
          closeGiftSuccessModal(); // Close SuccessGiftModal
          setOpen(false); // Ensure RedeemGiftModal stays closed
        }}
        proceed={redirectToPassbook}
      />
    </>
  );
};

export default ReceivedGifts;
